import { useInviteContext } from "@/containers/InviteWizard/InviteContext";
import Button from "@components/Button";
import Typography from "@components/Typography";
import { useWizard } from "@components/Wizard";

import styles from "../InviteWizard.module.css";

export type ReceiptProps = { className?: string };

const Receipt: React.FunctionComponent<ReceiptProps> = () => {
  const { user, reset } = useInviteContext();
  const { to } = useWizard();

  const resetWizard = () => {
    reset();
    to(0);
  };

  return (
    <div className={styles.receipt}>
      <Typography align="center" data-testid="user-add-receipt" variant="h3">
        {L.INVITE_WIZARD_INVITE_SENT} {user?.email}
      </Typography>

      <Button data-testid="user-add-invite-new-user" onClick={resetWizard}>
        {L.INVITE_WIZARD_NEW_INVITE}
      </Button>
    </div>
  );
};

export default Receipt;
